module.exports = __webpack_public_path__ + "static/media/assistive-listening-systems.3cd98350.svg";